import { render, staticRenderFns } from "./missing-details-step.vue?vue&type=template&id=980c74e4"
import script from "./missing-details-step.vue?vue&type=script&lang=js"
export * from "./missing-details-step.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports